import { memo, useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAppTheme } from '../context/theme.context';

/**
 * LoadingScreen — pantalla de carga que se muestra DEBAJO de la navbar.
 * Usa un pequeño spinner tras un retraso para evitar flash visual
 * en cargas rápidas.
 */
const LoadingScreen = memo(() => {
  const [show, setShow] = useState(false);
  const { colors } = useAppTheme();

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh', // Se reduce para no desbordar los layouts
        width: '100%',
      }}
    >
        <Box>
          {show && (
            <CircularProgress
              size={44}
              sx={{
                color: colors.accent,
                opacity: 0.8,
                '& .MuiCircularProgress-circle': {
                  strokeLinecap: 'round',
                },
              }}
            />
          )}
        </Box>
    </Box>
  );
});

LoadingScreen.displayName = 'LoadingScreen';

export default LoadingScreen;